import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { BcAccountClientService } from '../../service/bc-account-client.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { IMyDpOptions } from 'mydatepicker';
import { Subscription } from 'rxjs';
import * as moment from 'moment';
import 'moment/locale/pt-br';

export interface AttTitleModal {
	title: string;
	selectedBillings: any[];
}

@Component({
	selector: 'att-title-modal',
	templateUrl: './att-title-modal.component.html',
	styleUrls: ['./att-title-modal.component.scss'],
	providers: [ BcAccountClientService ]
})
export class AttTitleModalComponent extends DialogComponent<AttTitleModal, boolean> implements AttTitleModal {

	title: string;
	selectedBillings: any[] = [];
	public collectStatuses: any[] = [];


	public att: {} = {
		Texto: '',
		StatusCobrancaID: '',
		DataPrevisaoPagamento: '',
		DataAceite: '',
		TaxaJuros: '',
		TituloAtualizacaoStatusChaves: []
	}

	//Option to datepicker
	private myDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels:{su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab'},
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		//disableSince: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
		//disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		height: "30px"
	};

	constructor(dialogService: DialogService, private bcAccountClientService: BcAccountClientService, private flashMessagesService: FlashMessagesService) {
		super(dialogService);
	}

	ngOnInit() {
		this.getCollectStatus();
	}

	percentualCheck(e) {
		if (e.target.value.length > e.target.maxLength) {
			e.target.value = e.target.value.slice(0, e.target.maxLength);
		} else {
			if (e.target.value > 100) {
				e.target.value = 100;
			} else if (e.target.value < 0) {
				e.target.value = 0;
			}
		}
	}

	getCollectStatus() {
		this.bcAccountClientService.getCollectStatus().subscribe(result => {
			if (result.Success) {
				this.collectStatuses = result.Result;
				console.log("Status Titulos", result.Result);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	save() {
		let dataAceite;
		let dataPrevisaoPagamento;

		if (this.att['DataAceite']){
			dataAceite = moment(this.att['DataAceite'].jsdate).format("YYYY-MM-DD");
		}
		if (this.att['DataPrevisaoPagamento']){
			dataPrevisaoPagamento = moment(this.att['DataPrevisaoPagamento'].jsdate).format("YYYY-MM-DD");
		}

		this.att['TituloAtualizacaoStatusChaves'] = [];

		for (var i = 0; i < this.selectedBillings.length; i++) {
			this.att['TituloAtualizacaoStatusChaves'].push({
				NumeroDocumento: this.selectedBillings[i].NumeroDocumento,
				Linha: this.selectedBillings[i].Linha,
				AnoExercicio: this.selectedBillings[i].AnoExercicio,
				Empresa: this.selectedBillings[i].Empresa
			});
		}

		this.att["DataAceite"] = dataAceite;
		this.att["DataPrevisaoPagamento"] = dataPrevisaoPagamento;

		this.bcAccountClientService.saveTitleStatus(this.att).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Títulos atualizados com sucesso", { cssClass: 'alert-success', timeout: 6000 });
				this.result = true;
				this.close();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	canSave() {
		return this.att['Texto'] || this.att['StatusCobrancaID'] || this.att['DataPrevisaoPagamento'] || this.att['DataAceite'] || (this.att['TaxaJuros'] != null && this.att['TaxaJuros'] >= 0);
	}

	confirm() {
		this.close();
	}
}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-billing-list/att-title-modal/att-title-modal.component.ts